module.exports = __webpack_public_path__ + "img/base_template_image_ru.9394490a.png";